// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DOcw","top":"styles_top__3kUlR","left":"styles_left__6Q8cl","description":"styles_description__wnieW"};